import authApi from './auth';
import patientsApi from './patients';
import scheduleApi from './schedule';
import interventionsApi from './interventions';
import paymentsApi from './payments';
import expensesApi from './expenses';
import dashboardApi from './dashboard';
import companyApi from './company';
import profileApi from './profile';

export default {
  authApi,
  patientsApi,
  scheduleApi,
  interventionsApi,
  paymentsApi,
  expensesApi,
  dashboardApi,
  companyApi,
  profileApi,
};



// WEBPACK FOOTER //
// ./api/index.js